
import React from 'react'
//

export default () => (
  <div>
    <h1>This is what we're all about.</h1>
    <p>React, static sites, performance, speed. It's the stuff that makes us tick.</p>
  </div>
)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/About.js